module.exports = {
    //SecertKey: 'cd05e401-a0fa-4cd4-9a07-bee2e9284efc',
    // SecertKey: '2ab95587-2a96-46ee-978b-1dc6065d2b29',
    // SecertKey: 'b6c9a2b1-8eb3-484e-b44d-a6a45b56b5ae',
    // SecertKey: '17720495-c174-4317-82fb-1bdf82b98c89',
    SecertKey: 'abfea67e-e1dd-4c18-b4c6-8148e05cda89',

    // SecertKey: 'df0895cc-f2db-4954-9ed5-13365f1ea2cd',
    RoutUser: '/user',

}


// WEBPACK FOOTER //
// ./src/config/index.js